import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import WebpageDialog from './WebpageDialog';

export default function HelpButton({ url, windowTitle, color, style }) {

    const [showDialog, setShowDialog] = useState(false);

    const handleHelpClick = () => {
        if (windowTitle) {
            setShowDialog(true);
        } else {
            window.open(url, '_blank');
        }
    };

    return (
        <>
            {showDialog && <WebpageDialog title={windowTitle} url={url} onClose={() => setShowDialog(false)} />}
            <IconButton color={color} onClick={handleHelpClick} style={style}>
                <Tooltip title='View Help Files'>
                    <HelpIcon />
                </Tooltip>
            </IconButton>
        </>
    );
}
